// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__1tbQ8","slick-next":"CustomSlider_slick-next__2vuu0"};